import Address from '@/components/customercenter-ui/address/guestCheckout/ShippingAddress';
import { useCheckout } from '@/context/checkoutProvider';
import Payment from './Payment';

export interface GuestCheckoutPaymentProps {
  data: any;
  cartData: any;
  availableShippingMethods: any;
}

const GuestCheckoutPayment: React.FC<GuestCheckoutPaymentProps> = ({ data, cartData, availableShippingMethods }) => {
  const { shippingAddress } = useCheckout();

  return (
    <section>
      <Address
        address={shippingAddress}
        edit={false}
        color="#298842"
        cartData={cartData}
        availableShippingMethods={availableShippingMethods}
      />
      <Payment tasticData={data} />
    </section>
  );
};

export default GuestCheckoutPayment;
